import { useMountEffect } from "@react-hookz/web";
import type { FC } from "react";
import { useNavigate } from "react-router";

const EmployeeFieldsPage: FC = () => {
  const navigate = useNavigate();

  useMountEffect(() => navigate("/manage/employee_data/merge_tags", { replace: true }));

  return <></>;
};

export default EmployeeFieldsPage;
